import axios from 'axios'

// Check if we're in development mode (localhost)
const isLocalhost =
	window.location.hostname === 'localhost' ||
	window.location.hostname === '127.0.0.1' ||
	window.location.hostname.includes('192.168.')

// Use the proxy for local development to avoid CORS issues
const PROXY_URL = 'https://my-cors-anywhere24-3371cd77855e.herokuapp.com/'
const API_URL = 'https://lagerwelt3000.herokuapp.com'

// If running locally, prepend the proxy URL
export const baseURL = isLocalhost
	? process.env.REACT_APP_DATABASE_LOCATION || 'http://localhost:5000'
	: API_URL

const api = axios.create({
	baseURL,
	withCredentials: true,
})

export default api
